import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import PersonalCannedResponseAPI from '../../api/personalCannedResponse';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getPersonalCannedResponses(_state) {
    return _state.records;
  },
  getSortedPersonalCannedResponses(_state) {
    return sortOrder =>
      [..._state.records].sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.short_code.localeCompare(b.short_code);
        }
        return b.short_code.localeCompare(a.short_code);
      });
  },
  getPersonalCannedUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getPersonalCannedResponse: async function getPersonalCannedResponse(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, { fetchingList: true });
    try {
      const response = await PersonalCannedResponseAPI.get({ searchKey });
      commit(types.default.SET_PERSONAL_CANNED, response.data);
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        fetchingList: false,
      });
    } catch (error) {
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createPersonalCannedResponse: async function createPersonalCannedResponse(
    { commit },
    cannedObj
  ) {
    commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, { creatingItem: true });
    try {
      const response = await PersonalCannedResponseAPI.create(cannedObj);
      commit(types.default.ADD_PERSONAL_CANNED, response.data);
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        creatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        creatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  updatePersonalCannedResponse: async function updatePersonalCannedResponse(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, { updatingItem: true });
    try {
      const response = await PersonalCannedResponseAPI.update(id, updateObj);
      commit(types.default.EDIT_PERSONAL_CANNED, response.data);
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        updatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        updatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  deletePersonalCannedResponse: async function deletePersonalCannedResponse(
    { commit },
    id
  ) {
    commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, { deletingItem: true });
    try {
      await PersonalCannedResponseAPI.delete(id);
      commit(types.default.DELETE_PERSONAL_CANNED, id);
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        deletingItem: false,
      });
      return id;
    } catch (error) {
      commit(types.default.SET_PERSONAL_CANNED_UI_FLAG, {
        deletingItem: false,
      });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_PERSONAL_CANNED_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_PERSONAL_CANNED]: MutationHelpers.set,
  [types.default.ADD_PERSONAL_CANNED]: MutationHelpers.create,
  [types.default.EDIT_PERSONAL_CANNED]: MutationHelpers.update,
  [types.default.DELETE_PERSONAL_CANNED]: MutationHelpers.destroy,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
